"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FreeExtension = void 0;
var _react = require("react");
var _reactI18next = require("react-i18next");
var _store = require("../../../../redux/store");
var _popupSlice = require("../../../../redux/popupSlice");
var _retentionActionsSlice = require("../../../../redux/retentionActionsSlice");
var _Button = _interopRequireDefault(require("../../../Button"));
var _Loader = _interopRequireDefault(require("../../../Loader"));
var _InnerPopupWrapperStyled = require("../../../InnerPopupWrapper/InnerPopupWrapperStyled");
var _ThankYouPageStyled = require("../../../ThankYouPage/ThankYouPageStyled");
var _FreeExtensionError = _interopRequireDefault(require("./FreeExtensionError"));
var _FreeExtensionConfirmation = _interopRequireDefault(require("./FreeExtensionConfirmation"));
var _FreeExtension = require("./FreeExtension.styled");
var _jsxRuntime = require("react/jsx-runtime");
const FreeExtension = _ref => {
  let {
    handleUnsubscribe,
    setIsFreeExtensionSecondStep
  } = _ref;
  const {
    t
  } = (0, _reactI18next.useTranslation)();
  const dispatch = (0, _store.useAppDispatch)();
  const [isError, setIsError] = (0, _react.useState)(false);
  const [isThankYouPage, setIsThankYouPage] = (0, _react.useState)(false);
  const {
    isApplyLoading
  } = (0, _store.useAppSelector)(_retentionActionsSlice.selectRetentionActions);
  const {
    extensionDetails: {
      periodUnit,
      amount
    },
    offerId
  } = (0, _store.useAppSelector)(_retentionActionsSlice.selectOnlyRetentionActions);
  const handleApplyRetentionAction = async () => {
    await dispatch((0, _retentionActionsSlice.fetchApplyRetentionAction)(offerId)).unwrap().catch(() => {
      setIsError(true);
      setIsFreeExtensionSecondStep(true);
    });
    setIsThankYouPage(true);
    setIsFreeExtensionSecondStep(true);
  };
  const renderPeriodTextElement = () => {
    if (amount > 1) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: "".concat(amount, " ").concat(t("free-extension.period.".concat(periodUnit, "s"), '{{periodUnit}}s', {
          periodUnit
        }))
      });
    }
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
      children: "".concat(amount, " ").concat(t("free-extension.period.".concat(periodUnit), '{{periodUnit}}', {
        periodUnit
      }))
    });
  };
  if (isError) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeExtensionError.default, {});
  }
  if (isThankYouPage) {
    return /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeExtensionConfirmation.default, {});
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.ContentStyled, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FreeExtension.FreeExtensionWrapperStyled, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_FreeExtension.TextWrapperStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TitleStyled, {
          children: t('free-extension.title', 'How about a special offer just for you?')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
          children: t('free-extension.secondary-text', "No words can express how much we will miss you so we figured that we'll let this offer speak for itself.")
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_FreeExtension.FreeExtensionCardStyled, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_InnerPopupWrapperStyled.TextStyled, {
            children: t('free-extension.card-title', 'FREE EXTENSION')
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeExtension.FreeExtensionCardPeriodStyled, {
            children: renderPeriodTextElement()
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_FreeExtension.AcceptButtonWrapperStyled, {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
            theme: "confirm",
            size: "normal",
            onClickFn: handleApplyRetentionAction,
            children: isApplyLoading ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_Loader.default, {
              buttonLoader: true,
              color: "#ffffff"
            }) : t('free-extension.accept-button', 'I accept the offer')
          })
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_InnerPopupWrapperStyled.ButtonWrapperStyled, {
        $removeMargin: true,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.default, {
          theme: "simple",
          onClickFn: () => dispatch((0, _popupSlice.hidePopup)()),
          children: t('free-extension.back-button', 'Back to My Account')
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_ThankYouPageStyled.LinkStyled, {
          as: "button",
          onClick: handleUnsubscribe,
          children: t('free-extension.unsubscribe-button', 'I want to unsubscribe anyway')
        })]
      })]
    })
  });
};

// eslint-disable-next-line import/prefer-default-export
exports.FreeExtension = FreeExtension;